import { User } from "../types/userTypes";

export const tournamentEditAbility = (user?: User, ministry?: string) => {
  if (!user) return false;
  if (user.securityClearance.logonType === "ADMIN") return true;
  if (ministry && user.securityClearance.tournamentAccess?.includes(ministry))
    return true;
  return false;
};
